import { createContext } from 'react';

export type PanelSide = 'left' | 'right';

export type SidePanelSlots = Record<PanelSide, HTMLElement | null>;

export const SidePanelSlotsContext = createContext<SidePanelSlots>({
    left: null,
    right: null,
});
